export default __webpack_public_path__ + "static/media/Documents@32.cc5ab94c.svg";